export enum BulkImportJobStatusEnum {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export interface WarningItem {
  key: string;
  params?: Record<string, string>;
}

export interface ValidationItem {
  rowId: string;
  action: 'create' | 'update';
  data: Record<string, unknown>;
  errors: string[];
  warnings: WarningItem[];
  existingProductId?: string;
  canImport: boolean;
}

export interface ValidationSummary {
  totalItems: number;
  itemsToCreate: number;
  itemsToUpdate: number;
  itemsWithErrors: number;
  itemsCanImport: number;
  newCategories: string[];
  updatingCategories?: string[];
  newProviders: string[];
  updatingProviders?: string[];
  newWarehouses: string[];
  updatingWarehouses?: string[];
  missingRequiredFields: Record<string, number>;
}

export interface BulkImportValidationResponse {
  jobId: string;
  summary: ValidationSummary;
  items: ValidationItem[];
}

export interface BulkImportJobStatus {
  id: string;
  status: BulkImportJobStatusEnum;
  progressPercentage: number;
  currentStep: string | null;
  itemsProcessed: number;
  itemsSucceeded: number;
  itemsFailed: number;
  totalItems: number;
  errors?: Record<string, unknown>[];
  startedAt?: string;
  completedAt?: string;
  isStuck?: boolean;
  autoResumed?: boolean;
}

export interface ActiveBulkImportJob {
  id: string;
  status: BulkImportJobStatusEnum;
  progressPercentage: number;
  fileName?: string;
  totalItems: number;
  itemsProcessed: number;
  startedAt?: string;
}
